export async function callUsButton() {
  const isMobile = /android|iphone/i.test(navigator.userAgent);
  const url = new URL(window.location.href);
  const firstSegment = url.pathname.split('/')[1];

  if (isMobile && firstSegment.match(/^[a-z]{2}-[a-z]{2}$/i)) {
    const [lang, country] = firstSegment.split('-');
    const response = await fetch('/api/phone/' + country);

    if (response.status === 200) {
      const json = await response.json();
      const phone = json.phone;
      const phoneElement = document.body.querySelector('.call-us-action a');
      phoneElement.href = 'tel:' + phone;

    }
  }
}
